"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImplementation = void 0;
var global_this_1 = __importDefault(require("core-js-pure/stable/global-this"));
function getImplementation(options, key) {
    var _a;
    var result = (_a = options[key]) !== null && _a !== void 0 ? _a : global_this_1.default[key];
    if (!result) {
        throw new ReferenceError("\"" + key + "\" is not defined");
    }
    return result;
}
exports.getImplementation = getImplementation;
//# sourceMappingURL=utils.js.map